import { DrawingModel } from '@/models/DrawingModel'

/**
 * 手書き用のペン情報
 */
export namespace PenSetting {
  /**
   * 黒ペン(通常のペン)
   */
  export const PEN_BLACK: DrawingModel.PenAsset = {
    name: 'black',
    lineCap: 'round',
    lineJoin: 'round',
    lineWidth: 2,
    color: '#000000',
    isEraser: false,
  }

  /**
   * 消しゴム
   */
  export const ERASER: DrawingModel.PenAsset = {
    name: 'eraser',
    lineCap: 'round',
    lineJoin: 'round',
    lineWidth: 2,
    color: '#ff0000',
    isEraser: true,
  }
}
